import { AUTORI, PAGINEDETAIL, TEMI } from 'utils/endpoint'
import React from 'react'
import { api } from 'utils'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import { useRouter } from 'next/router'
import BoxAutori from 'components/BoxAutori'
import BoxRisorse from 'components/BoxRisorse'
import BoxCatalogo from 'components/BoxCatalogo'
import BoxTemaDelMomento from 'components/BoxTemaDelMomento'
import BoxTagCloud from 'components/BoxTagCloud'
import Head from 'next/head'

const HubDetail = React.memo(({ pagina, statusCode, autori, risorseSponsorizzate }) => {
  if (!pagina) return <Error statusCode={statusCode} />

  const router = useRouter()

  const background = pagina.main_image
    ? { backgroundImage: `url(${pagina.main_image})` }
    : { backgroundColor: `black` }

  const urlRisorse = `${
    router.asPath.split('?')[0]
  }/risorse?filtri_id=${pagina.valori_attributo.join('/')}`

  const urlAutori = `/autori?filtri_id=${pagina.valori_attributo.join('/')}`

  const showBoxCatalogo = router.asPath.includes('primaria')

  return (
    <>
      {pagina ? (
        <main className="hub-page">
          <MetaSeo seo={pagina.seo} />
          {pagina.main_image ? (
            <Head>
              <link rel="preload" href={pagina.main_image} as="image" />
            </Head>
          ) : null}
          <div className="w-container-fluid u-before-section u-background-image" style={background}>
            <div className="w-container">
              <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
            </div>

            <section className="hub-page__header">
              <div className="w-container">
                <h1 className="hub-page__header__title">{pagina.titolo}</h1>
              </div>
            </section>
          </div>

          <section className="hub-page__content u-bg-white">
            <div className="w-container">
              {showBoxCatalogo && (
                <div className="hub-page__content__cataloghi">
                  <BoxCatalogo
                    title="Catalogo libri di testo"
                    description="Volumi e collane per arricchire, ripassare, esercitarsi nello studio di tutte le materie a scuola e a casa. Scegli quello che ti interessa!"
                    primaryCta="Esplora il catalogo"
                    primaryHref="/corsoadozionale"
                    secondaryCta="Vai a DBook Easy"
                    secondaryBlank
                    secondaryHref="https://dbookeasy.giuntiscuola.it/"
                    imgHref="/images/catalogo_adozionale.png"
                  />
                  <BoxCatalogo
                    title="Catalogo parascolastico"
                    description="Volumi e collane per arricchire, ripassare, esercitarsi nello studio di tutte le materie a scuola e a casa. Scegli quello che ti interessa!"
                    primaryCta="Esplora il catalogo"
                    primaryHref="/parascolastico"
                    secondaryCta="Attiva prodotto"
                    secondaryHref="/attiva-prodotto"
                    imgHref="/images/catalogo_parascolastico.png"
                  />
                </div>
              )}
              {pagina.tag_cloud.length ? (
                <BoxTagCloud
                  title={`Esplora le materie ${pagina.titolo}`}
                  description={`Qui trovi gli argomenti più cercati dalla community di Giunti Scuola. Trova quello che fa per te e prepara la tua prossima lezione. ${pagina.titolo}`}
                  tags={pagina.tag_cloud}
                  baseHref={urlRisorse}
                />
              ) : null}
            </div>
            {pagina.tema_del_momento ? (
              <BoxTemaDelMomento
                tema={pagina.tema_del_momento}
                variant="blue"
                items={risorseSponsorizzate}
              />
            ) : (
              <BoxRisorse href={urlRisorse} />
            )}
            {autori.length ? <BoxAutori autori={autori} href={urlAutori} /> : null}
            {pagina.tema_del_momento && <BoxRisorse href={urlRisorse} />}
          </section>
        </main>
      ) : null}
    </>
  )
})

export const getStaticProps = async () => {
  const response = await api.get(PAGINEDETAIL, { params: { path: '/scuolasecondaria' } })
  const pagina = await response.data

  const toolbarProps = { toolbarPage: pagina }

  const params = {
    attributi__valore_attributo_id: pagina.valori_attributo.join(','),
    limit: 4,
    relevance: 1,
  }

  const autoriResponse = await api.get(AUTORI, { params })
  const autori = autoriResponse.data || []

  let risorseSponsorizzate = null
  if (pagina.tema_del_momento) {
    const risorseSponsorizzateResponse = await api.get(
      `${TEMI}${pagina.tema_del_momento.id}/risorse_sponsorizzate/`,
      {
        params: { limit: 3 },
      }
    )
    risorseSponsorizzate = risorseSponsorizzateResponse.data.risorse
  }

  return {
    props: { pagina, key: pagina.id, ...toolbarProps, autori, risorseSponsorizzate },
    revalidate: 60 * 2,
  }
}

export default HubDetail
